var _style, _g, _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArticle = function SvgArticle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "article_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".article_svg__st0{fill:none}.article_svg__st2{fill:#172d72}.article_svg__st3{fill:#be1d32}")), /*#__PURE__*/React.createElement("g", {
    id: "article_svg__\\u7EC4_5977",
    transform: "translate(-83.562 -132.128)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "article_svg__\\u7EC4_5963",
    transform: "translate(83.562 132.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5289",
    className: "article_svg__st0",
    d: "M0 0h56v56H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "article_svg__\\u7EC4_5966",
    transform: "translate(95.635 140.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "article_svg__\\u7EC4_5964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u8DEF\\u5F84_17291",
    d: "M24 0H0v40h32V8l-8-8z",
    style: {
      fill: "#e2e5ee"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5290",
    className: "article_svg__st2",
    d: "M4 7.9h10.1v4H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5291",
    className: "article_svg__st2",
    d: "M4 15.9h20v4H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u77E9\\u5F62_5292",
    className: "article_svg__st3",
    d: "M4 24h10.1v4H4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "article_svg__\\u692D\\u5706_1333",
    className: "article_svg__st3",
    cx: 22,
    cy: 26,
    r: 2.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u8DEF\\u5F84_17292",
    className: "article_svg__st2",
    d: "m24 0 8 8h-8V0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "article_svg__\\u76F4\\u7EBF_390",
    className: "article_svg__st0",
    d: "m24 0 8 8"
  })))));
};
export default SvgArticle;